import WallView from "../views/WallView";
import { PerspectiveCamera } from "three";
import { maxHeight, wallLength } from "../controllers/wallControllers";


/**
 * Positions and rotates a camera to frame an isolated wall within the camera's
 * field of view. This makes the camera a child of the wall for the sake of
 * simplicity.
 *
 * Note that if you change the camera's fov, you may need to call
 * camera.updateProjectionMatrix(). This method only re-positions the camera,
 * so I don't update the projection matrix here.
 *
 * @param camera - the camera to modify
 * @param wall - the wall to look at
 * @param aspect - the aspect ratio of the rendering, i.e. canvas width/height
 * @param margin - amount of additional space above/below or left/right of the
 * wall to include in the view
 */
const lookAtWall = (
    camera: PerspectiveCamera,
    wall: WallView,
    aspect: number = 1,
    margin: number = 12) =>
{
    const
        length = wall.model.showExtension
            ? wallLength(wall.model) + wall.model.leftExtension + wall.model.rightExtension
            : wallLength(wall.model),
        halfWidth = length / 2,
        halfHeight = maxHeight(wall.model) / 2,
        // vFov is half the camera.fov converted from degrees to radians
        vFov = camera.fov * Math.PI / 360,
        hFov = vFov * aspect,
        z = Math.max(
            (halfHeight + margin) / Math.tan(vFov),
            (halfWidth + margin) / Math.tan(hFov)
        );
    
    wall.add(camera);
    camera.position.x = halfWidth;
    camera.position.y = halfHeight;
    camera.position.z = z;
    camera.rotation.set(0, 0, 0);
};

export default lookAtWall;
